import { parseMarkdown } from "../../../core/index.js";

export function escapeBubbleHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function formatBubbleTimestamp(timestamp) {
  if (!timestamp) {
    return "";
  }
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function formatBubbleDuration(
  startTimestamp,
  endTimestamp,
  mode = "formatted"
) {
  if (!startTimestamp || !endTimestamp) {
    return "";
  }

  const start =
    startTimestamp instanceof Date
      ? startTimestamp
      : new Date(startTimestamp);
  const end =
    endTimestamp instanceof Date ? endTimestamp : new Date(endTimestamp);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return "";
  }

  const durationMs = Math.max(0, end.getTime() - start.getTime());
  if (mode === "milliseconds") {
    return `${Math.round(durationMs)}ms`;
  }

  const totalSeconds = Math.floor(durationMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const milliseconds = Math.round(durationMs % 1000);
  const parts = [`${milliseconds}ms`];

  if (totalSeconds >= 1) {
    parts.unshift(`${seconds}s`);
    if (totalSeconds >= 60) {
      parts.unshift(`${minutes}m`);
      if (totalSeconds >= 3600) {
        parts.unshift(`${hours}h`);
      }
    }
  }

  return parts.join(" ");
}

export function renderMarkdownBubblePanel({
  role = "assistant",
  html = "",
  extraClassName = "",
  dataAttributes = "",
}) {
  return `
    <div
      class="bubble-controller-panel bubble-controller-panel-${escapeBubbleHtml(
        role
      )}${extraClassName ? ` ${escapeBubbleHtml(extraClassName)}` : ""}"
      data-bubble-context-menu-target="true"
      ${dataAttributes}
    >
      <div class="bubble-controller-markdown">${html || ""}</div>
    </div>
  `.trim();
}

export function renderBubbleFooter({
  role = "assistant",
  timestamp = "",
  footerActionsHtml = "",
}) {
  if (!timestamp && !footerActionsHtml) {
    return "";
  }

  return `
    <div class="bubble-controller-footer bubble-controller-footer-${escapeBubbleHtml(
      role
    )}">
      ${
        timestamp
          ? `<div class="bubble-controller-timestamp">${escapeBubbleHtml(
              timestamp
            )}</div>`
          : ""
      }
      ${footerActionsHtml || ""}
    </div>
  `.trim();
}

export function renderMarkdownContent(content = "") {
  return parseMarkdown(content || "");
}
